export const executeWithLogging = async <T>(
  func: () => Promise<T>
): Promise<T> => {
  try {
    return await func();
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export function withLogging(
  target: any,
  key: string,
  meta: PropertyDescriptor
) {
  const origin = meta.value;

  meta.value = function (...data: any[]) {
    const result = origin.apply(this, data);

    return result instanceof Promise
      ? result.catch(error => {
          console.warn(`Error in ${key}: ${error}`);

          throw error;
        })
      : result;
  };
}

export const executeWithLoggingAndCache = async <T>(
  func: () => Promise<T>,
  cacheKey: string,
  ttl: number
): Promise<T> => {
  try {
    return await func();
  } catch (e) {
    console.log(e);
    throw e;
  }
  // TODO: cache
  // return await queryWithCache(
  //     async () => {
  //         try {
  //             return await func();
  //         } catch (e) {
  //             console.log(e);
  //             throw e;
  //         }
  //     },
  //     cacheKey,
  //     ttl
  // );
};
